<template>
    <div class="SubscriptionStatusAlert" v-if="isVisible">
        <div>
            <Icon name="exclamation-triangle"/>
            <p>{{ message }} </p>
        </div>
        <Button v-if="user.role === 'owner'" to="/company/settings" class="white sm">Make Payment</Button>
        <Button v-else to="/support" class="sm">Request Support</Button>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'SubscriptionStatusAlert',

    computed: {
        ...mapState('auth', ['user']),
        ...mapState('company', ['subscription']),
        ...mapGetters('company', ['subscriptionSuspended']),

        isVisible() {
            if (!this.subscription) {
                return true;
            }

            return this.subscriptionSuspended || ['past_due', 'unpaid'].includes(this.subscription.status);
        },

        message() {
            if (this.subscriptionSuspended) {
                if (this.user.role !== 'owner') {
                    return 'Your subscription has been suspended. Please have the account owner renew to continue using DumpTek.'
                }

                return 'Your subscription has been suspended. Please renew it to continue using DumpTek.';
            } else {
                if (this.user.role !== 'owner') {
                    return 'We couldn\'t process your payment. Please have the account owner update billing info to avoid suspension.';
                }

                return 'We couldn\'t process your payment. Please update your billing info to avoid suspension.'
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SubscriptionStatusAlert {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px $grid-gutter-width;
        background-color: $red-color;
        font-weight: $font-weight-bold;
        color: #fff;

        @include breakpoint(md) {
            display: block;
        }

        div {
            display: flex;
            align-items: center;

            @include breakpoint(md) {
                justify-content: center;
            }

            .Icon {
                margin-right: $grid-gutter-width;
                flex-shrink: 0;
            }
        }

        .Button {
            width: 100%;
            max-width: 200px;
            margin-left: $grid-gutter-width;

            @include breakpoint(md) {
                display: block;
                margin: $grid-gutter-width auto 0;
            }
        }
}
</style>
